@use "../../styles/breakpoint.module.scss" as *;

.withoutMedia {
    padding-block: var(--spacer-152) var(--spacer-64);
}

.content {
    position: relative;

    @media ($below-mobile) {
        margin-left: var(--container-margin);
        margin-right: var(--container-margin);
    }

    .withMedia & {
        margin-block: var(--spacer-80) var(--spacer-40);

        @media ($above-mobile) {
            padding-right: var(--spacer-24);
        }

        @media ($below-mobile) {
            flex-direction: column;
            align-items: flex-start;
            gap: var(--spacer-24);
            margin-bottom: var(--spacer-8);
        }
    }
}

.media {
    @media ($above-mobile) {
        width: calc(100% + var(--labui-container-margin));
        min-height: 720px;
    }
}

.backLink {
    position: absolute;
    left: 0;
    top: 0;
    display: inline-flex;
    flex-direction: row-reverse;
    gap: var(--spacer-4);
    align-items: center;
    font: var(--font-eyebrow-14);
    text-transform: uppercase;
    letter-spacing: 0.04em;

    .withoutMedia & {
        translate: 0 -200%;
    }

    .withMedia & {
        @media ($below-mobile) {
            position: static;
        }
    }

    svg {
        width: 1em;
        height: 1em;
        transform: scale(-1, 1);
        flex-shrink: 0;
    }
}

.richText {
    :global(.eyebrow) {
        font-size: var(--font-eyebrow-16);
    }
}
